// Khoá ô "thêm thợ trang điểm" của một đơn — QĐ 0199, CEO chốt câu 1a và 3a
// ngày 25/09/2026.
//
// Một hàm cho CẢ HAI màn có ô phân công (tab Ekip của màn Đơn, ô chi tiết của
// màn Lịch) để hai nơi không bao giờ nói hai kiểu về cùng một luật — đúng cặp
// với errMakeupNotSold bên máy chủ.
//
// Máy chủ mới là rào thật (cửa gán từ chối bằng 400 kèm nguyên câu lý do).
// Chỗ này chỉ để người dùng KHỎI bấm vào chỗ chắc chắn hỏng.

/** Câu nói với người dùng khi đơn không có chỗ cho thợ trang điểm. */
export const MAKEUP_NOT_SOLD_REASON =
  "Gói này không kèm trang điểm — thêm mục trang điểm vào đơn trước rồi mới phân công thợ.";

/**
 * Trả lý do khoá, hoặc undefined khi KHÔNG khoá.
 *
 * Chỉ khoá khi máy chủ nói CHẮC (`makeupCrewAllowed === false`). Trường này là
 * ba trạng thái: thiếu / null = chưa biết (cửa không tính cờ, danh mục đọc
 * hỏng, mã gói lạ) — khi ấy để ô chọn sống. Khoá oan là lễ tân đứng cạnh khách
 * mà không phân công được ai, và không có đường vòng nào; còn mở thừa thì cùng
 * lắm là bấm vào rồi đọc đúng câu lý do ấy từ máy chủ.
 */
export function makeupCrewLockReason(
  order: { makeupCrewAllowed?: boolean | null } | null | undefined,
): string | undefined {
  return order?.makeupCrewAllowed === false ? MAKEUP_NOT_SOLD_REASON : undefined;
}

/** Câu khoá thẻ Retouch — cùng câu 409 của cửa gán người (QĐ 0466). */
export const RETOUCH_AWAITING_PAYMENT_REASON =
  "Khách chưa thanh toán ảnh chọn thêm — chưa gán thợ hậu kỳ được";

/**
 * Khoá thẻ Retouch khi đơn album còn nợ tiền ảnh vượt gói (QĐ 0466). Chỉ khoá
 * khi máy chủ nói chắc `true`; vắng = chưa biết ⇒ không khoá (máy chủ vẫn chặn).
 * Gỡ người không bị chặn — thẻ khoá chỉ nút "＋ Thêm".
 */
export function retouchCrewLockReason(
  order: { awaitingExtraPayment?: boolean | null } | null | undefined,
): string | undefined {
  return order?.awaitingExtraPayment === true ? RETOUCH_AWAITING_PAYMENT_REASON : undefined;
}
